<div class="container-1440">
    <div class="page-container">
        <div fxLayout="column" fxLayoutAlign="start" class="product-detail-container">
            <div fxLayout="row" fxLayoutAlign="start center" class="breadcrumb-container">
                <a href="/">Home /</a>
                <a *ngFor="let category of breadcrumb; index as i" [href]="'/#/products/' + category.id">{{category.categoryEavs | getValueByAttribute:'displayName':'value'}} <span *ngIf="i < breadcrumb.length - 1">/</span></a>
            </div>
            <app-product-content [product]="product"></app-product-content>
            <div class="w-100">
                <div class="product-description">
                    <div>DESCRIPTION</div>
                    <div class="description">
                        <div [innerHTML]="product.productSkus[0].productSkuEavs | getValueByAttribute:'description':'value'"></div>
                        <!-- <ul>
                            <li>Crewneck</li>
                            <li>Iconic fleece logo embroidered at the chest</li>
                            <li>Rib-knit banding at cuffs and hem</li>
                            <li>70% cotton, 30% polyester</li>
                            <li>Machine wash</li>
                            <li>Imported</li>
                            <li>Roomier fit. Size down for a fitted look</li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div *ngIf="crossSaleProducts && crossSaleProducts.length > 0" class="w-100 slider-section">
                <app-product-slider [products]="crossSaleProducts" title1="May" title2="We Suggest"></app-product-slider>
            </div>
            <div *ngIf="recentlyViewProducts && recentlyViewProducts.length > 0" class="w-100 slider-section">
                <app-product-slider [products]="recentlyViewProducts" title1="" title2="Recently Viewed"></app-product-slider>
            </div>
        </div>
    </div>
</div>
